export default "__VITE_ASSET__Db13rNHu__"